import { AppSettings } from '../settings/app-settings.model';
import { BaseService } from './base.service';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class BaseApiService extends BaseService<AppSettings.ApiSettings> {
    constructor() {
        super(s => s.api);
    }

    protected handleErrorResponse(error: HttpErrorResponse) {
        if (error.error) {
            return throwError(error.error);
        } else {
            return throwError('Server error');
        }
    }
}
